import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: "Immediatamente dopo l'acquisto ricevi un link di download diretto nella tua email. Nessuna attesa, nessuna spedizione fisica."
}, {
  q: 'È adattato per classi con diversi livelli?',
  a: 'Sì. Ogni tomo include materiali differenziati per livello Base, Intermedio e Avanzato, adatti sia alle Medie che alle Superiori.'
}, {
  q: 'I materiali sono stampabili?',
  a: 'Sì. Tutti i PDF sono ottimizzati per la stampa in bianco e nero o a colori, sia in formato A4 che A5.'
}, {
  q: 'La valutazione è conforme alle linee guida MIM?',
  a: 'Sì. Tutte le griglie di valutazione sono allineate alle ultime Indicazioni Nazionali MIM 2025/2026.'
}, {
  q: 'Per quale classe è pensato il kit?',
  a: "Il sistema copre l'intero ciclo della Scuola Secondaria: dalla Prima Media fino alla Quinta Superiore, inclusa la preparazione alla Maturità."
}, {
  q: 'Posso utilizzarlo anche con studenti DSA o BES?',
  a: "Assolutamente. Il Bonus dedicato all'inclusività BES/DSA include mappe, schede facilitate e verifiche compensative conformi alla Legge 170/2010."
}, {
  q: 'Quanto tempo ci vuole per scaricare i materiali?',
  a: 'Meno di 2 minuti. Ricevi il link via email e scarichi tutto in un unico file organizzato per tomo e per classe.'
}, {
  q: 'Posso usare i contenuti per più anni scolastici?',
  a: 'Sì. Una volta acquistato il kit è tuo per sempre. Puoi utilizzarlo ogni anno scolastico senza costi aggiuntivi.'
}, {
  q: 'Come funziona la garanzia di 14 giorni?',
  a: "Se entro 14 giorni dall'acquisto non sei soddisfatto, ti rimborsiamo ogni centesimo senza fare domande. Basta un'email."
}, {
  q: 'Quali sono i metodi di pagamento accettati?',
  a: 'Accettiamo tutte le principali carte di credito e debito, PayPal e pagamenti sicuri tramite Stripe.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-10 uppercase text-brand-cream" data-id="element-89">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-3" data-id="element-90">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-92">
                <span className="font-bold text-brand-cream text-sm sm:text-base" data-id="element-93">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-94" />
              </button>

              <AnimatePresence data-id="element-95">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="px-5 pb-5 pt-0 text-gray-400 font-medium text-sm sm:text-base leading-relaxed" data-id="element-97">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}